import { TokenService } from "@/providers/tokens/tokens.service";

import { type ITokens } from "./auth.interface";

export function setToken(data: ITokens, rememberMe: boolean): ITokens {
  TokenService.setTokens( data?.accessToken,  data?.refreshToken, !rememberMe);
  return data;
}
